import React, { useEffect, useRef, useState } from "react";
import { addBlog, addCourseFees, addGallery, getColleges, getCourseCategories, getCourses, getGalleryByCollege, getUniversities, updateGallery } from "../../Services/HomeService";
import toast from "react-hot-toast";
import HttpClientXml from "../../utils/HttpClientXml";
import moment from "moment";
import ReactQuill from "react-quill";
import { useLocation, useNavigate } from "react-router-dom";

const modules = {
  toolbar: [
    [{ header: [1, 2, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [{ list: "ordered" }, { list: "bullet" }],
    ["link"],
    ["clean"],
  ],
};

const ManageGallery = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const { college } = location.state || {};

  const headLineStyle = {
    textAlign: "center",
    fontSize: "30px",
    color: "rgb(131, 144, 155)",
    margin: "0px 0px 10px 0px",
    fontWeight: "bold",
  };

  const tabNames = [
    {
      value: "Overview",
      label: "Overview"
    },
    {
      value: "Courses & Fees",
      label: "Courses & Fees"
    },

    {
      value: "Admission",
      label: "Admission"
    },
    {
      value: "Scholarship",
      label: "Scholarship"
    },
    {
      value: "Placements",
      label: "Placements"
    },
    {
      value: "CutOffs",
      label: "CutOffs"
    },
    {
      value: "Ranking",
      label: "Ranking"
    },
    {
      value: "Campus",
      label: "Campus"
    },
    {
      value: "Reviews",
      label: "Reviews"
    },
    {
      value: "Fees",
      label: "Fees"
    }
  ]

  const fileInputRef = useRef(null);
  const [universities, setUniversities] = useState([]);
  const [fetchUniversitiesLoading, setFetchUniversitiesLoading] = useState(false);
  const [colleges, setColleges] = useState([]);
  const [fetchCollegesLoading, setFetchCollegesLoading] = useState(false);
  const [courseCategories, setCourseCategories] = useState([]);
  const [fetchCourseCategoriesLoading, setCourseCategoriesLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [fetchCoursesLoading, setFetchCoursesLoading] = useState(false);
  const [uploading, setUploading] = useState(false)
  const [createLoading, setCreateLoading] = useState(false);
  const [galleryLoading, setGalleryLoading] = useState(false)
  const [galleryImages, setGalleryImages] = useState([])
  const [isGalleryExists, setIsGalleryExists] = useState(false)
  const [galleryID, setGalleryID] = useState(null)

  const initialValues = {
    collegeId: college,
    images: [],
    videos: []
  }

  const [formData, setFormData] = useState(initialValues)

  const fetchColleges = async () => {
    try {
      setFetchCollegesLoading(true);
      const res = await getColleges();
      console.log("fetched Colleges", res?.data);
      if (res?.status) {
        setColleges(res?.data);
        setFetchCollegesLoading(false);
      } else {
        toast.error("Error while Fetching Colleges Data");
        setFetchCollegesLoading(false);
      }
    } catch (error) {
      toast.error("failed to fetch Colleges Data");
      console.error("Error fetching Colleges:", error);
      setFetchCollegesLoading(false);
    }
  };

  const fetchGallery = async (collegeId) => {
    try {
      setGalleryLoading(true);
      const res = await getGalleryByCollege(collegeId);
      console.log("CDR195", res);
      if (res?.status) {
        setGalleryImages(res?.data[0]?.images)
        setGalleryID(res?.data?._id)
        setIsGalleryExists(true)
        setGalleryLoading(false);
      } else {
        // toast.error("Error while Fetching Colleges Gallery");
        setGalleryLoading(false);
        setIsGalleryExists(false)
        setGalleryImages(null)
        setGalleryID(null)
      }
    } catch (error) {
      // toast.error("failed to fetch Colleges Gallery");
      console.error("Error fetching Colleges:", error);
      setGalleryLoading(false);
      setIsGalleryExists(false)
      setGalleryImages(null)
      setGalleryID(null)
    }
  };

  const handleFileUpload = async (e) => {
    e.preventDefault()
    setUploading(true)
    const data = new FormData();
    data.append("image", e.target.files[0]);
    try {
      const res = await HttpClientXml.fileUplode("image-upload", "POST", data);
      console.log("KJH124", res);

      if (res?.image) {
        setFormData({ ...formData, image: res.image })
        toast.success("Image uploaded successfully!");
      }
    } catch (error) {
      toast.error("Failed to upload image.");
      console.error("Error uploading image:", error);
    } finally {
      setUploading(false)
      fileInputRef.current.value = null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setCreateLoading(true)
    let newGalleryImages = []

    if (images.length) {
      const uploadFormData = new FormData();
      console.log("KJH173", images);

      images.forEach((img) => {
        uploadFormData.append("images", img.file);
      });
      const res = await HttpClientXml.fileUplode("multi-image-upload", "POST", uploadFormData);

      
      if (galleryImages?.length) {
        newGalleryImages = [...galleryImages, ...res?.images]
      } else {
        newGalleryImages = res?.images
      }
      setGalleryImages(newGalleryImages)
      setImages([])
      fileInputRef.current.value = null;
    }else{
      newGalleryImages =galleryImages
    }

    const updateFormData = {
      collegeId: formData?.collegeId,
      images: newGalleryImages,
      videos: []
    }

    console.log("LOI201",updateFormData);
    
    // return

    try {
      setCreateLoading(true);
      let res = null
      if (galleryID && isGalleryExists) {
        res = await updateGallery(galleryID, updateFormData);
      } else {
        res = await addGallery(updateFormData);
      }

      console.log("Gallery Update Message", res);
      if (res?.status) {
        toast.success(res?.message);
        // setFormData(initialValues)
        setIsGalleryExists(true)
        setCreateLoading(false);
        navigate("/manage-college-university");
      } else {
        toast.error(res?.message);
        setCreateLoading(false);
      }
    } catch (error) {
      toast.error("Failed to add Blog.");
      console.error("Error adding Blog:", error);
      setCreateLoading(false);
    }
  };

  useEffect(() => {
    fetchColleges()
  }, [])

  ///////////////////////////////////////
  const [images, setImages] = useState([]);

  // Handle file selection
  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const newImages = files.map((file) => ({
      file,
      preview: URL.createObjectURL(file),
    }));
    setImages((prev) => [...prev, ...newImages]);
  };

  // Remove image
  const removeImage = (index) => {
    setImages((prev) => prev.filter((_, i) => i !== index));
  };

  const removeGalleryImage = (index) => {
    console.log("LOI246", galleryImages[index]);
    setGalleryImages((prev) => prev.filter((_, i) => i !== index));
  };

  const handleCancel = () => {
    navigate("/manage-college-university");
  };


  useEffect(() => {
    console.log("KIU229", formData?.collegeId, "688b26268d41f6d4db062661");


    formData?.collegeId && fetchGallery(formData?.collegeId)
  }, [formData?.collegeId])

  console.log("CFT256", college);

  return (
    <>
      <div className="main_wrap" style={{ marginTop: "6rem" }}>
        <div className="container-fluid">
          <div style={headLineStyle} className="page-headline">
            Manage Gallery
          </div>
          <section className="chartBox_area">
            <form
              onSubmit={(e) => {
                handleSubmit(e);
              }}
            >
              <div className="row d-flex justify-content-center">

                <div
                  className="col-md-12 mt-3"
                  style={{
                    display: "none"
                  }}
                >
                  <label htmlFor="name">
                    College Name<span className="text-danger">*</span>
                  </label>
                  <select
                    onChange={(e) => {
                      setFormData((prev) => ({
                        ...prev,
                        collegeId: e?.target?.value,
                      }));
                    }}
                    value={formData?.collegeId}
                    className="form-control"
                    disabled
                  >
                    <option value="">
                      -------- Select College --------
                    </option>
                    {fetchCollegesLoading ? (
                      <option>Loading...</option>
                    ) : colleges?.length === 0 ? (
                      <option>No College Found</option>
                    ) : (
                      colleges.map((e, i) => {
                        return (
                          <option key={i} value={e?._id}>
                            {e?.name}
                          </option>
                        );
                      })
                    )}
                  </select>
                </div>

                <div
                  className="col-md-12 mt-3"
                >
                  <label htmlFor="name">
                    Gallery Image(s)
                  </label>

                  <div>

                    {/* Existing Gallery */}
                    <div className="row g-3 mb-4">
                      {
                        galleryImages?.length > 0 ? (
                          <>
                            {
                              galleryImages?.map((img, index) => (
                                <div
                                  key={index}
                                  className="col-6 col-sm-4 col-md-3 col-lg-2 _position-relative"
                                >
                                  {/* Image */}
                                  <img
                                    src={img}
                                    alt="preview"
                                    className="img-fluid rounded shadow-sm"
                                    style={{ height: "150px", objectFit: "cover", width: "100%" }}
                                  />

                                  {/* Cross button OVER the image */}
                                  <button
                                    type="button"
                                    onClick={() => removeGalleryImage(index)}
                                    className="btn btn-sm btn-danger position-absolute top-50 start-50 translate-middle"
                                    style={{
                                      borderRadius: "50%",
                                      width: "32px",
                                      height: "32px",
                                      padding: 0,
                                      marginLeft: "-40px",
                                      marginTop: "5px"
                                    }}
                                  >
                                    ✕
                                  </button>
                                </div>
                              ))
                            }
                          </>

                        ) : (
                          <>
                            <p className="col-sm-12 position-relative">No photos are found in the gallery. Browse images and SAVE to upload in the gallery</p>
                          </>
                        )


                      }
                    </div>





                    {/* Preview Gallery */}
                    <div className="row g-3 mb-4">
                      {images.map((img, index) => (
                        <div
                          key={index}
                          className="col-6 col-sm-4 col-md-3 col-lg-2 _position-relative"
                        >
                          {/* Image */}
                          <img
                            src={img.preview}
                            alt="preview"
                            className="img-fluid rounded shadow-sm"
                            style={{ height: "150px", objectFit: "cover", width: "100%" }}
                          />

                          {/* Cross button OVER the image */}
                          <button
                            type="button"
                            onClick={() => removeImage(index)}
                            className="btn btn-sm btn-danger position-absolute top-50 start-50 translate-middle"
                            style={{
                              borderRadius: "50%",
                              width: "32px",
                              height: "32px",
                              padding: 0,
                              marginLeft: "-40px",
                              marginTop: "5px"
                            }}
                          >
                            ✕
                          </button>
                        </div>
                      ))}
                    </div>

                    {/* File Upload */}
                    <input
                      type="file"
                      ref={fileInputRef}
                      multiple
                      accept="image/*"
                      onChange={handleImageChange}
                      className="form-control mb-4"
                    />

                  </div>

                </div>



              </div>
              <div className=" d-flex justify-content-center" style={{ gap: "15px" }}>
                <button
                  onClick={() => {
                    handleCancel();
                  }}
                  type="button"
                  className="btn mt-3"
                  style={{
                    background: "#f77754",
                    borderRadius: "13px",
                  }}
                >
                  Cancel
                </button>
                {
                  (galleryImages?.length > 0 || images.length > 0) && (
                    // <div className=" d-flex justify-content-center">


                    <button
                      disabled={createLoading}
                      type="submit"
                      className="btn mt-3"
                      style={{
                        background: "rgb(133, 218, 79)",
                        borderRadius: "13px",
                      }}
                    >
                      {createLoading
                        ? "Saving data..."
                        : "Save Gallery"}
                    </button>

                  )}
              </div>

            </form>
          </section>
        </div>
      </div>
    </>
  );
};

export default ManageGallery;
